/**
 *
 * Utility to set all the providers on a provider factory
 *
 * @param providerFactory
 * @param props
 * @param extensionProvider
 * @param quickInsertProvider
 */
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/max-params
export default function handleProviders(providerFactory, _ref, extensionProvider, quickInsertProvider) {
  var mentionProvider = _ref.mentionProvider,
    contextIdentifierProvider = _ref.contextIdentifierProvider,
    collabEditProvider = _ref.collabEditProvider,
    activityProvider = _ref.activityProvider,
    presenceProvider = _ref.presenceProvider,
    macroProvider = _ref.macroProvider,
    imageUploadProvider = _ref.imageUploadProvider,
    searchProvider = _ref.searchProvider;
  providerFactory.setProvider('mentionProvider', mentionProvider);
  providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
  providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
  providerFactory.setProvider('collabEditProvider', collabEditProvider);
  providerFactory.setProvider('activityProvider', activityProvider);
  providerFactory.setProvider('searchProvider', searchProvider);
  providerFactory.setProvider('presenceProvider', presenceProvider);
  providerFactory.setProvider('macroProvider', macroProvider);
  if (extensionProvider) {
    providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
  }
  if (quickInsertProvider) {
    providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
  }
}